import React from "react";
import { FormattedMessage } from "react-intl";
function extractUniqueNumbersFromString(str) {
  return [...new Set(str?.match(/\d+/g)?.map(Number) ?? [])];
}
function CodeErrorMessage({
  error,
  errorCodeMessages,
  defaultErrorMessage,
  errorsToShow = "highestRanked",
  hasError
}) {
  const errorCodes = extractUniqueNumbersFromString(error)?.map((e) => errorCodeMessages[e]).filter((e) => e !== void 0);
  const sortedErrors = errorCodes.sort((a, b) => (b.rank ?? 0) - (a.rank ?? 0));
  function getErrorMessages() {
    const messages = [];
    if (sortedErrors.length === 0) {
      messages.push(defaultErrorMessage);
    } else {
      switch (errorsToShow) {
        case "highestRanked":
          {
            const highestRankedError = sortedErrors[0];
            if (highestRankedError) {
              messages.push(highestRankedError.message);
            }
          }
          break;
        case "allHighestRanked":
          {
            const highestRankedErrors = sortedErrors.filter((e) => e.rank === sortedErrors[0].rank);
            highestRankedErrors.forEach((e) => messages.push(e.message));
          }
          break;
        case "all":
          sortedErrors.forEach((e) => messages.push(e.message));
          break;
      }
    }
    return messages;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, hasError && getErrorMessages().map((message, index) => /* @__PURE__ */ React.createElement(FormattedMessage, { key: index, ...message })));
}
export {
  CodeErrorMessage
};
//# sourceMappingURL=CodeErrorMessage.js.map
